import breakpointsEnum from "../enums/breakpointsEnum";
import GoodsEnum from "../enums/goodsEnum";
import Cart from '../common/Cart';
import 'select2/dist/js/select2.js';
import 'select2/dist/css/select2.css';

$(function () {
    let App = window.App;
    App.addingToCart = {};

    const getQuantityProduct = (sign, $productCount, $productCountSelect) => {
        let quantity;

        if (sign !== undefined) {
            let prevValue = parseInt($productCount.text());
            quantity = eval(prevValue + sign + 1);
        } else {
            quantity = parseInt($productCountSelect.val());
        }

        return quantity;
    };

    const checkQuantityProduct = (productType, productId, quantity) => {
        if (quantity.new < quantity.min) {
            if (window.App.getBreakpoint() === breakpointsEnum.mobile) {
                removeFromCart(productType, productId);
                
                return false;
            } else {
                quantity.new = quantity.min;
            }
        } else if (quantity.new > quantity.max) {
            quantity.new = quantity.max;
        }
    }

    const checkProductLimit = ($form, $fixedPanelCounter, quantity) => {
        let maximumValueReached = Number(quantity.new === quantity.max);

        $form.attr('data-maximum-value-reached', maximumValueReached);
        $fixedPanelCounter.attr('data-maximum-value-reached', maximumValueReached);
    }

    const setNewValue = ($this, $productCount, $productCountSelect, $fixedPanelCounter, newValue) => {
        if (!$this.is('select')) {
            $productCountSelect.val(newValue).trigger('change');
        }

        $fixedPanelCounter.find('.product-count').text(newValue);
        $productCount.text(newValue);
    }

    App.addingToCart.checkOut = (e, $this) => {
        e.preventDefault();
        $this.addClass('pending');

        Cart.checkOut($this, $this.attr('href'));
    }

    App.addingToCart.changeQuantity = function ($this, productType, productId, sign = undefined) {
        let $form = $('#counterForm'),
            $productCountSelect = $('#productCountSelect', $form),
            $productCount = $('#productCount', $form),
            $fixedPanelCounter = $(`.fixed-panel .counter-label[data-product-id="${productId}"]`);

        let quantity = {
            min: parseInt($productCountSelect.data('min')),
            max: parseInt($productCountSelect.data('max')),
            new: getQuantityProduct(sign, $productCount, $productCountSelect)
        }

        if (checkQuantityProduct(productType, productId, quantity) === false) {
            return false;
        }

        setNewValue($this, $productCount, $productCountSelect, $fixedPanelCounter, quantity.new);
        checkProductLimit($form, $fixedPanelCounter, quantity);

        const delta = quantity.new - parseInt($productCountSelect.attr('data-count'));

        $productCountSelect.attr('data-count', quantity.new);
        
        Cart.change(productType, productId, quantity.new, delta);
    }

    App.addingToCart.addProduct = (event, type, $this, withSuccessModal = true) => {
        event.preventDefault();

        if ($this.hasClass('pending')) {
            return false;
        }

        let productId = $this.data('buy');

        if (productId === undefined) {
            console.error('Error: Product undefined.');
            return false;
        }

        let $addToCartButtons = $(`button[data-buy="${productId}"`);

        $.ajax({
            type: 'POST',
            url: (type === GoodsEnum.certificate) && '/cart/add-certificate' || '/cart/add',
            data: {
                id: productId,
                count: 1
            },
            dataType: 'json',
            beforeSend: function () {
                $this.addClass('pending');
            },
            complete: function () {
                $this.removeClass('pending');
            },
            success: function (response) {
                if (withSuccessModal && response.hasOwnProperty('modal_view')) {
                    $('footer').before(response.modal_view);

                    let modalId = $(response.modal_view).attr('id'),
                        $modal = $(`#${modalId}`);

                    if ($modal.length) {
                        App.modal.open($modal);
                        window.App.lazyImageLoading();

                        $('#productCountSelect', $modal).select2({
                            minimumResultsForSearch: Infinity,
                            width: '90px',
                            dropdownParent: $('#counterForm', $modal)
                        }).on('select2:select', function () {
                            App.addingToCart.changeQuantity($(this), type, productId);
                        });
                    }
                }

                if (response.hasOwnProperty('total')) {
                    App.updateCounters(null, null, null, response.total);
                }

                $addToCartButtons.addClass('active');

                if (type === GoodsEnum.product) {
                    if (response.hasOwnProperty('modelForAnalytics')) {
                        App.analytics.ecommerceCartItemChange(response.modelForAnalytics, 1);
                        App.analytics.carrotQuestAddingToCart(response.modelForAnalytics);
                    }

                    App.analytics.sendAnalyticsGoal('nazali_kupit');
                    App.analytics.facebookPixelAddingToCart(productId);
                }
            }
        });
    }

    const removeFromCart = (type, id) => {
        App.modal.closeOpenModal();

        Cart.remove(type, id);
    }
});